var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTlBenchmarkGreyNotPurchased(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.33 188.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d8dde1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tl_benchmark_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard_b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.45,957.59a65.84,65.84,0,1,1,65.84-65.83,65.9,65.9,0,0,1-65.84,65.83",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.62,929.61a4.13,4.13,0,0,1-1.49,2.82,4.17,4.17,0,0,1-5.87-.54,37.46,37.46,0,0,0-57.62,0,4.18,4.18,0,0,1-3.21,1.49,4.13,4.13,0,0,1-2.66-1,4.21,4.21,0,0,1-.53-5.88,45.87,45.87,0,0,1,70.44,0,4.08,4.08,0,0,1,.94,3",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.45,870.09a6.67,6.67,0,1,0,6.67,6.67,6.67,6.67,0,0,0-6.67-6.67",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.45,870.09a6.67,6.67,0,1,0,6.67,6.67,6.67,6.67,0,0,0-6.67-6.67",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.45,817.59a74.17,74.17,0,1,0,74.17,74.17,74.25,74.25,0,0,0-74.17-74.17m0,140a65.84,65.84,0,1,1,65.84-65.83,65.9,65.9,0,0,1-65.84,65.83",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.45,997.59a65.84,65.84,0,1,1,65.84-65.83,65.9,65.9,0,0,1-65.84,65.83",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.62,953.86a4.13,4.13,0,0,0-1.49-2.82,4.17,4.17,0,0,0-5.87.54,37.46,37.46,0,0,1-57.62,0,4.18,4.18,0,0,0-3.21-1.49,4.13,4.13,0,0,0-2.66,1,4.21,4.21,0,0,0-.53,5.88,45.87,45.87,0,0,0,70.44,0,4.08,4.08,0,0,0,.94-3",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.45,910.09a6.67,6.67,0,1,0,6.67,6.67,6.67,6.67,0,0,0-6.67-6.67",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.45,910.09a6.67,6.67,0,1,0,6.67,6.67,6.67,6.67,0,0,0-6.67-6.67",
    transform: "translate(-67.29 -817.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.45,857.59a74.17,74.17,0,1,0,74.17,74.17,74.25,74.25,0,0,0-74.17-74.17m0,140a65.84,65.84,0,1,1,65.84-65.83,65.9,65.9,0,0,1-65.84,65.83",
    transform: "translate(-67.29 -817.59)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlBenchmarkGreyNotPurchased);
export default __webpack_public_path__ + "static/media/tl_benchmark_grey_not_purchased.98eb1554cb2c256b5733175add435030.svg";
export { ForwardRef as ReactComponent };